<template>
    <div>
        <Card>
            <Row :gutter="16">
                <Col span="24">
                <div class="global-tool-bar">
                    <div class="left-bar">
                        <span class="title">发票申请列表</span>
                    </div>
                    <div class="right-bar" />
                </div>
                </Col>
            </Row>
            <Row v-if="mainTable.sarchCardShow" :gutter="16">
                <Col span="24">
                <search-card ref="searchCard" :form="mainTable.searchForm" :table-load-event="getMainTableRecords"
                    :table-search="mainTable.tableSearch" />
                </Col>
            </Row>

            <Row :gutter="16">
                <Col span="24">
                <stand-pagination-table :columns="mainTable.tableColumns" :data="mainTable.tableData" :extHeight="60"
                    :loading="mainTable.tableLoading" :table-search="mainTable.tableSearch"
                    :table-load-event="getMainTableRecords" />
                </Col>
            </Row>
        </Card>

        <PreSaleDeliveryDetail ref="preSaleDeliveryDetailModal" />
        <InvoicePreviewModal ref="invoicePreviewModal" />
    </div>
</template>

<script>
import SearchCard from '@/components/searchCard/searchCard.vue';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import search from '@/libs/search';
import { formatUserType } from '@/view/login/UserTypeDefine';
import { number2ThousandsFormat, numberToFixed } from '@/components/number-input/display-format';
import { dateTimeRender } from '@/libs/tableRowTimeRender';
import { getInvoiceRecord, webGetInvoice, getInvoiceInfo, accounterWithdrawInvoice, accounterMarkFinishInvoice } from '@/api/modules/finance-management/invoice';
import { getThisMonthStart, getTodayDateString } from '@/libs/logic';
import PreSaleDeliveryDetail from '@/view/preSale-management/preSale-delivery/preSale-delivery-detail.vue';
import InvoicePreviewModal from './invoice-preview.vue';

export default {
    name: 'BankRecordList',
    components: {
        SearchCard,
        StandPaginationTable,
        PreSaleDeliveryDetail,
        InvoicePreviewModal
    },
    data() {
        return {
            mainTable: {
                tableColumns: [
                    { title: '行号', type: 'index', width: 60, align: 'center' },
                    { title: '发票编号', key: 'invoiceCode', width: 140, align: 'center' },
                    { title: '申请时间', key: 'invoiceUserAppliedAt', width: 130, align: 'center', render: (h, params) => dateTimeRender(h, params.row.invoiceUserAppliedAt) },
                    { title: '申请人', key: 'invoiceUserApplier', width: 80, align: 'center' },
                    {
                        title: '关联单号', key: 'relateOrder', width: 150, align: 'center',
                        render: (h, params) => {
                            let newArr = [];
                            params.row.relateOrder.forEach((e, index) => {
                                newArr.push(
                                    h('div', [h('a', {
                                        on: {
                                            click: () => {
                                                this.$refs.preSaleDeliveryDetailModal.showModal(e.item1);
                                            }
                                        }
                                    }, e.item2)])
                                );
                            });
                            return h('div', newArr);
                        }
                    },
                    {
                        title: '开票金额',
                        key: 'invoiceValue',
                        width: 100,
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('span', {}, number2ThousandsFormat(params.row.invoiceValue, 2, '￥'))
                            ]);
                        }
                    },

                    { title: '开票抬头', key: 'invoiceBuyerName', width: 200, align: 'center' },
                    { title: '发票类型', key: 'invoiceLine1', width: 100, align: 'center' },
                    { title: '介质类型', key: 'invoiceLine2', width: 80, align: 'center' },
                    { title: '开具类型', key: 'invoiceBuyerType', width: 60, align: 'center' },
                    { title: '状态', key: 'invoiceStatus', width: 80, align: 'center' },
                    { title: '开票平台', key: 'platform', width: 80, align: 'center' },
                    { title: '邮寄地址', key: 'invoiceDeliveryAddress', width: 200, align: 'center' },
                    {
                        title: '操作',
                        key: 'action1',
                        align: 'center',
                        width: 120,
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small',
                                        shape: 'circle'
                                    },
                                    style: {
                                        display: params.row.invoiceLine2 === '纸质发票' || params.row.invoiceStatus === '申请成功' && params.row.invoiceLine2 === '电子发票' ? 'inline' : 'none'
                                    },
                                    on: {
                                        click: () => {
                                            if (params.row.invoiceLine2 === '电子发票') {
                                                this.showInvoice(params.row);
                                            }
                                            else {
                                                this.preViewInvoice(params.row);
                                            }

                                        }
                                    }
                                }, '查看'),
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small',
                                        shape: 'circle'
                                    },
                                    style: {
                                        display: params.row.invoiceStatus === '申请处理中' ? 'inline' : 'none'
                                    },
                                    on: {
                                        click: () => {
                                            this.markFinishInvoice(params.row);
                                        }
                                    }
                                }, '确认开票'),
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small',
                                        shape: 'circle'
                                    },
                                    style: {
                                        display: params.row.invoiceLine1 !== '增值税专用发票' && params.row.invoiceStatus !== '信息已填写' ? 'inline' : 'none'
                                    },
                                    on: {
                                        click: () => {
                                            this.withdrawInvoice(params.row);
                                        }
                                    }
                                }, '撤销')
                            ]);
                        }
                    }

                ],
                tableData: [],
                tableLoading: false,
                tableSearch: search.getSearchParams(),
                sarchCardShow: true,
                searchForm: [
                    { label: '申请人', type: 'Input', value: '', name: 'invoiceUserApplier', sql: 'like' },
                    { label: '申请时间', type: 'Daterange', value: [], name: 'invoiceUserAppliedAt', sql: 'dateBetween' },
                    {
                        label: '状态', type: 'Select', value: [], options: [
                            { value: '信息已填写', key: '信息已填写' }, { value: '申请处理中', key: '申请处理中' }, { value: '申请成功', key: '申请成功' }, { value: '开票失败', key: '开票失败' }
                        ], name: 'invoiceStatus', sql: 'in'
                    }
                ]
            }
        };
    },
    mounted() {
        // let beginEndDate = this.mainTable.searchForm.find(e => {
        //     return e.name === 'invoiceUserAppliedAt';
        // });
        // beginEndDate.value = [this.getThisMonthStart(), this.getTodayDateString()];
        // this.$refs.searchCard.handleSearch();
        this.init();
    },
    methods: {
        getTodayDateString,
        getThisMonthStart,
        numberToFixed,
        init() {
            this.getMainTableRecords();
        },
        smalltoBIG(n) {
            let fraction = ['角', '分'];
            let digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
            let unit = [['元', '万', '亿'], ['', '拾', '佰', '仟']];
            let head = n < 0 ? '欠' : '';
            n = Math.abs(n);

            let s = '';

            for (let i = 0; i < fraction.length; i++) {
                s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '');
            }
            s = s || '整';
            n = Math.floor(n);

            for (let i = 0; i < unit[0].length && n > 0; i++) {
                let p = '';
                for (let j = 0; j < unit[1].length && n > 0; j++) {
                    p = digit[n % 10] + unit[1][j] + p;
                    n = Math.floor(n / 10);
                }
                s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s;
            }
            return head + s.replace(/(零.)*零元/, '元').replace(/(零.)+/g, '零').replace(/^整$/, '零元整');
        },
        getCurrentDate() {
            let now = new Date();
            let year = now.getFullYear(); //得到年份
            let month = now.getMonth();//得到月份
            let date = now.getDate();//得到日期
            month = month + 1;
            if (month < 10) month = "0" + month;
            if (date < 10) date = "0" + date;
            let time = "";
            time = year + "年" + month + "月" + date + "日";
            return time;
        },
        markFinishInvoice(row) {
            this.$Modal.confirm({
                title: '确认标识已开票?',
                onOk: () => {
                    this.mainTable.tableLoading = true;
                    accounterMarkFinishInvoice({ invoiceUuid: row.invoiceUuid }).then(res => {
                        this.mainTable.tableLoading = false;
                        if (res.code === 0) {
                            this.$Modal.success({
                                title: '操作成功',
                                onOk: () => {
                                    this.getMainTableRecords();
                                }
                            });

                        }
                    });
                }
            });
        },
        showInvoice(row) {
            let data = {
                serialNo: row.invoiceSerialNum
            };
            this.mainTable.tableLoading = true;
            getInvoiceInfo(data).then(res => {
                this.mainTable.tableLoading = false;
                if (res.code === 0) {
                    window.open(res.data.pdfurl, "_blank");
                }
            });
        },
        withdrawInvoice(row) {
            this.$Modal.confirm({
                title: '确认撤销开票申请?',
                onOk: () => {
                    this.mainTable.tableLoading = true;
                    accounterWithdrawInvoice({ invoiceUuid: row.invoiceUuid }).then(res => {
                        this.mainTable.tableLoading = false;
                        if (res.code === 0) {
                            this.$Modal.success({
                                title: '撤销成功',
                                onOk: () => {
                                    this.getMainTableRecords();
                                }
                            });

                        }
                    });
                }
            });
        },
        preViewInvoice(row) {
            this.mainTable.tableLoading = true;
            webGetInvoice({ deliveryUuidList: row.invoiceDeliveryUuidList.split(',') }).then(res => {
                if (res.code === 0) {
                    this.mainTable.tableLoading = false;
                    this.$refs.invoicePreviewModal.showModal(res.data);
                }
            });
        },
        getMainTableRecords(reset = false) {
            this.mainTable.tableLoading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
            getInvoiceRecord(this.mainTable.tableSearch).then(res => {
                if (res.code === 0) {
                    this.mainTable.tableData = res.data.records;
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                }

                this.mainTable.tableLoading = false;
            });
        }
    }
};
</script>

<style scoped>
.vertical-text {
    -webkit-writing-mode: vertical-rl;
    writing-mode: vertical-rl;
    text-align: center;
    line-height: 2;
}

.invoiceBorder {
    border-right: 0.5px solid;
    border-bottom: 0.5px solid;
    border-color: black;
}
</style>
